<script setup>

</script>

<template>
  <div id="app">
    <!-- Router orqali yuklanadigan komponentlar uchun joy -->
    <router-view />
  </div>
</template>

<style>
/* Umumiy stilni bu yerda qo'shishingiz mumkin */

</style>
